<!-- Это самый главный файл, инициализирующий всё приложение. -->
<template>
    <div class="content" @click="defineRoute()">
      <the-navbar />
      <transition name="slide-pageTransition">
        <router-view></router-view>
      </transition>
    </div>
    <div class="footer">
      <the-footer />
    </div>
</template>

<script>

import {computed} from 'vue'
import {useRoute} from 'vue-router' // обращаемся к нашему роуту
import {useStore} from 'vuex'

// импортируем наши основные layouts

import MainLayout from "@/layouts/MainLayout";
import TheFooter from "@/components/TheFooter";
import TheNavbar from "@/components/TheNavbar";
import ServiceLayout from "@/layouts/ServiceLayout";
import RepairLayout from "@/layouts/RepairLayout";
import ChangeLayout from "@/layouts/ChangeLayout";
import AdminLayout from "@/layouts/AdminLayout";
import UserLayout from "@/layouts/UserLayout";
//import AppMessage from "@/components/ui/AppMessage";

export default {
  setup() {
    const store = useStore()
    const router = useRoute()

    function defineRoute() {
      store.state.route = router.path
    }

    return {
      store,
      router,
      defineRoute,
      layout: computed(() =>
          router.component // динамически получаем наш layout
      )
    }

  },
  components: {
    TheFooter, TheNavbar, MainLayout, ServiceLayout, RepairLayout, ChangeLayout, AdminLayout, UserLayout}
}

</script>

<style scoped>

.content {
  flex: 1 0 auto;
}

.footer{
  flex: 0 0 auto;
}
</style>
